import Vue from "vue";
import App from "./App.vue";
import store from "./store";

// global export of all components
// nicked from https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
const requireComponent = require.context("./widgets", false, /[A-Z]\w+.vue$/);
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    const componentName = componentConfig.default.name;
    Vue.component(componentName, componentConfig.default || componentConfig);
});

if (window.localStorage.getItem("known")) {
    // if we think we know the user, be proactive and go fetch profile
    store.commit("setLoggedIn", true);
    store.dispatch("_fetchProfile");
}

Vue.config.productionTip = false;
new Vue({
    store,
    render: h => h(App),
}).$mount("#app");
